import { EmailCampaignSignupSingleBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpEmailCampaignSignupSingleBlock } from './AmpEmailCampaignSignupSingleBlock';
import { EmailCampaignSignupSingleBlock } from './EmailCampaignSignupSingleBlock';

export const EmailCampaignSignupSingleBlockMapping: BlockMapping<EmailCampaignSignupSingleBlockData> =
  {
    invariant: [
      {
        prop: 'headline',
        msg: 'Heading required for Email Campaign Signup Single',
      },
      {
        prop: 'buttonText',
        msg: 'Button Text required for Email Campaign Signup Single',
      },
      {
        prop: 'campaignId',
        msg: 'Campaign ID required for Email Campaign Signup Single',
      },
      {
        prop: 'listId',
        msg: 'List ID required for Email Campaign Signup Single',
      },
    ],
    width: 'GRID',
    Component: EmailCampaignSignupSingleBlock,
    AmpComponent: AmpEmailCampaignSignupSingleBlock,
  };
